import { createRouter, createWebHistory } from 'vue-router'

// 路由配置
const routes = [
  {
    path: '/',
    // 重定向到登录页，确保未登录用户默认看到登录界面
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login.vue'),
    meta: {
      title: '登录',
      requiresAuth: false
    }
  },
  {
    path: '/select-identity',
    name: 'SelectIdentity',
    component: () => import('@/views/auth/SelectIdentity.vue'),
    meta: {
      title: '选择身份',
      requiresAuth: true
    }
  },
  {
    path: '/select-store',
    name: 'SelectStore',
    component: () => import('@/views/auth/SelectStore.vue'),
    meta: {
      title: '选择门店',
      requiresAuth: true
    }
  },
  {
    path: '/no-stores',
    name: 'NoStores',
    component: () => import('@/views/auth/NoStores.vue'),
    meta: {
      title: '无可用门店',
      requiresAuth: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: () => import('@/views/dashboard/Overview.vue'),
        meta: {
          title: '概览',
          keepAlive: true
        }
      },
      {
        path: 'order',
        name: 'Order',
        component: () => import('@/views/order/Order.vue'),
        meta: {
          title: '订单管理',
          keepAlive: true
        }
      },
      {
        path: 'refund-review',
        name: 'RefundReview',
        component: () => import('@/views/order/RefundReview.vue'),
        meta: {
          title: '退款订单',
          keepAlive: true
        }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/profile/Profile.vue'),
        meta: {
          title: '个人中心',
          keepAlive: true
        }
      },
      {
        path: 'agent',
        name: 'Agent',
        component: () => import('@/views/agent/Agent.vue'),
        meta: {
          title: '代理商管理',
          keepAlive: true
        }
      },
      {
        path: 'store',
        name: 'Store',
        component: () => import('@/views/store/Store.vue'),
        meta: {
          title: '门店管理',
          keepAlive: true
        }
      },
      {
        path: 'device',
        name: 'Device',
        component: () => import('@/views/device/Device.vue'),
        meta: {
          title: '设备管理',
          keepAlive: true
        }
      },
      {
        path: 'sticker-qrcode',
        name: 'StickerQRCode',
        component: () => import('@/views/device/StickerQRCode.vue'),
        meta: {
          title: '贴纸二维码',
          keepAlive: true
        }
      },
      {
        path: 'paper-stock',
        name: 'PaperStock',
        component: () => import('@/views/device/PaperStock.vue'),
        meta: {
          title: '纸张库存',
          keepAlive: true
        }
      },
      {
        path: 'employee',
        name: 'Employee',
        component: () => import('@/views/employee/Employee.vue'),
        meta: {
          title: '员工管理',
          keepAlive: true
        }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('@/views/user/User.vue'),
        meta: {
          title: '用户管理',
          keepAlive: true
        }
      },
      {
        path: 'marketing',
        name: 'Marketing',
        component: () => import('@/views/marketing/Marketing.vue'),
        meta: {
          title: '营销管理',
          keepAlive: true
        }
      },
      {
        path: 'marketing/activities',
        name: 'MarketingActivities',
        component: () => import('@/views/marketing/MarketingActivities.vue'),
        meta: {
          title: '营销活动',
          keepAlive: true,
          permission: 'MARKETING_MANAGE'
        }
      },
      {
        path: 'marketing/points',
        name: 'PointsManagement',
        component: () => import('@/views/marketing/PointsManagement.vue'),
        meta: {
          title: '积分与广告管理',
          keepAlive: true
        }
      },
      {
        path: 'coupon',
        name: 'Coupon',
        component: () => import('@/views/coupon/Coupon.vue'),
        meta: {
          title: '优惠券管理',
          keepAlive: true
        }
      },
      {
        path: 'finance',
        name: 'Finance',
        component: () => import('@/views/finance/Finance.vue'),
        meta: {
          title: '财务管理',
          keepAlive: true
        }
      },
      {
        path: 'payment-management',
        name: 'PaymentManagement',
        component: () => import('@/views/finance/PaymentManagement.vue'),
        meta: {
          title: '支付管理',
          keepAlive: true
        }
      },
      {
        path: 'print-task',
        name: 'PrintTask',
        component: () => import('@/views/print/PrintTask.vue'),
        meta: {
          title: '打印任务管理',
          keepAlive: true
        }
      },
      {
        path: 'print-type',
        name: 'PrintType',
        component: () => import('@/views/print/PrintType.vue'),
        meta: {
          title: '打印类型管理',
          keepAlive: true
        }
      },
      {
        path: 'print-option',
        name: 'PrintOption',
        component: () => import('@/views/print/PrintOption.vue'),
        meta: {
          title: '打印选项管理',
          keepAlive: true
        }
      },
      {
        path: 'print-log',
        name: 'PrintLog',
        component: () => import('@/views/print/PrintLog.vue'),
        meta: {
          title: '打印日志管理',
          keepAlive: true
        }
      },
      {
        path: 'print/logs',
        name: 'PrintLogs',
        component: () => import('@/views/print/PrintLog.vue'),
        meta: {
          title: '打印日志管理',
          keepAlive: true,
          permission: 'LOG_VIEW'
        }
      },
      {
        path: 'consumable',
        name: 'Consumable',
        component: () => import('@/views/consumable/Consumable.vue'),
        meta: {
          title: '耗材管理',
          keepAlive: true
        }
      },
      {
        path: 'file',
        name: 'File',
        component: () => import('@/views/file/File.vue'),
        meta: {
          title: '文件管理',
          keepAlive: true
        }
      },
      {
        path: 'library',
        name: 'Library',
        component: () => import('@/views/library/Library.vue'),
        meta: {
          title: '文库管理',
          keepAlive: true
        }
      },
      {
        path: 'library/categories',
        name: 'LibraryCategory',
        component: () => import('@/views/library/CategoryManage.vue'),
        meta: {
          title: '文库分类管理',
          keepAlive: true
        }
      },
      {
        path: 'application',
        name: 'Application',
        component: () => import('@/views/application/ApplicationList.vue'),
        meta: {
          title: '申请管理',
          keepAlive: true
        }
      },
      {
        path: 'ads',
        name: 'Ads',
        component: () => import('@/views/marketing/Ads.vue'),
        meta: {
          title: '广告管理',
          keepAlive: true
        }
      },
      {
        path: 'recharge/activity',
        name: 'RechargeActivity',
        component: () => import('@/views/recharge/RechargeActivity.vue'),
        meta: {
          title: '充值活动管理',
          keepAlive: true
        }
      },
      {
        path: 'payment/config',
        name: 'PaymentConfig',
        component: () => import('@/views/payment/PaymentConfig.vue'),
        meta: {
          title: '支付配置管理',
          keepAlive: true
        }
      },
      {
        path: 'system',
        name: 'System',
        component: () => import('@/views/system/System.vue'),
        meta: {
          title: '系统管理',
          keepAlive: true
        }
      },
      {
        path: 'system/permission-approval',
        name: 'SystemPermissionApproval',
        component: () => import('@/views/system/PermissionApproval.vue'),
        meta: {
          title: '权限审批',
          keepAlive: true,
          permission: 'PERMISSION_MANAGE'
        }
      },
      {
        path: 'config',
        name: 'Config',
        component: () => import('@/views/config/DistributedConfig.vue'),
        meta: {
          title: '系统配置',
          keepAlive: true
        }
      },
      {
        path: 'system/status',
        name: 'SystemStatus',
        component: () => import('@/views/system/Status.vue'),
        meta: {
          title: '系统状态监控',
          keepAlive: true
        }
      },
      {
        path: 'system/monitor',
        name: 'SystemMonitor',
        component: () => import('@/views/system/Monitor.vue'),
        meta: {
          title: '监控仪表板',
          keepAlive: true
        }
      },
      {
        path: 'system/logs',
        name: 'SystemLogs',
        component: () => import('@/views/system/Logs.vue'),
        meta: {
          title: '操作日志',
          keepAlive: true
        }
      },
      {
        path: 'system/agreement',
        name: 'SystemAgreement',
        component: () => import('@/views/system/Agreement.vue'),
        meta: {
          title: '用户注册协议',
          keepAlive: true
        }
      },
      {
        path: 'system/backups',
        name: 'SystemBackups',
        component: () => import('@/views/system/Backups.vue'),
        meta: {
          title: '数据备份',
          keepAlive: true
        }
      },
      {
        path: 'system/versions',
        name: 'SystemVersions',
        component: () => import('@/views/system/VersionManagement.vue'),
        meta: {
          title: '终端版本管理',
          keepAlive: true
        }
      },
      {
        path: 'system/global-prices',
        name: 'SystemGlobalPrices',
        component: () => import('@/views/system/GlobalPrices.vue'),
        meta: {
          title: '全局价格配置',
          keepAlive: true
        }
      },
      {
        path: 'system/third-party',
        name: 'SystemThirdParty',
        component: () => import('@/views/system/ThirdParty.vue'),
        meta: {
          title: '第三方配置',
          keepAlive: true
        }
      },
      {
        path: 'system/message-template',
        name: 'MessageTemplate',
        component: () => import('@/views/system/MessageTemplate.vue'),
        meta: {
          title: '消息模板管理',
          keepAlive: true
        }
      },
      {
        path: 'system/drivers',
        name: 'DriverManagement',
        component: () => import('@/views/system/DriverManagement.vue'),
        meta: {
          title: '驱动管理',
          keepAlive: true
        }
      },

      {
        path: 'store-employee',
        name: 'StoreEmployee',
        component: () => import('@/views/store-employee/StoreEmployee.vue'),
        meta: {
          title: '门店员工管理',
          keepAlive: true
        }
      },
      {
        path: 'split-account',
        name: 'SplitAccount',
        component: () => import('@/views/splitAccount/SplitAccount.vue'),
        meta: {
          title: '分账账号管理',
          keepAlive: true
        }
      },
      {
        path: 'split-account/batch',
        name: 'SplitAccountBatch',
        component: () => import('@/views/splitAccount/SplitAccountBatch.vue'),
        meta: {
          title: '分账批量审核',
          keepAlive: true
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    meta: {
      title: '页面未找到'
    }
  }
]

// 路由缓存策略
const cachePages = [
  'Overview',
  'Order',
  'Agent',
  'Store',
  'Device',
  'User',
  'Finance',
  'System'
]

// 创建路由实例
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0, behavior: 'smooth' }
    }
  }
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 性能监控：记录路由开始时间
  const startTime = performance.now()

  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - 自助打印系统`
  }

  // 判断路由是否需要认证
  if (to.meta.requiresAuth !== false) {
    try {
      // 检查是否登录
      const token = localStorage.getItem('token')
      const userInfo = localStorage.getItem('userInfo')

      if (!token || !userInfo) {
        throw new Error('未登录或登录已过期')
      }

      // 验证token有效性
      const parsedUserInfo = JSON.parse(userInfo)
      // 灵活处理用户ID字段，支持大写ID和小写id
      const userId = parsedUserInfo.id || parsedUserInfo.ID
      if (!userId || !parsedUserInfo.username) {
        throw new Error('用户信息无效')
      }
      // 确保用户信息中包含id字段
      if (!parsedUserInfo.id) {
        parsedUserInfo.id = userId
      }

      // 检查用户是否是系统管理员或代理商
      const isAdmin = parsedUserInfo.role === 'ADMIN' || parsedUserInfo.role === 'SUPER_ADMIN' || parsedUserInfo.role === 'admin' || parsedUserInfo.username === 'nyadmin'
      const isAgent = parsedUserInfo.role === 'AGENT' || parsedUserInfo.role === 'agent'
      const activeIdentity = localStorage.getItem('activeIdentity')

      // 权限验证（管理员跳过权限检查）
      if (to.meta.permission && !isAdmin) {
        const userPermissions = parsedUserInfo.permissions || []
        if (!userPermissions.includes(to.meta.permission)) {
          throw new Error('权限不足，无法访问该页面')
        }
      }

      // 检查是否需要选择门店
      const currentStore = localStorage.getItem('currentStore')
      const stores = localStorage.getItem('stores')
      const storesArray = stores ? JSON.parse(stores) : []

      // 判断当前用户是否需要选门店：
      // - 管理员：不选门店
      // - 代理商（activeIdentity=AGENT）：不选门店
      // - 代理商选了门店身份（activeIdentity=STORE）：需要选门店
      // - 普通门店用户：需要选门店
      const needsStoreSelection = !isAdmin && activeIdentity !== 'AGENT' && !(isAgent && !activeIdentity)

      // 如果不是门店选择页面和无门店页面，且用户需要选门店但未选择，跳转到门店选择页面
      if (needsStoreSelection && to.name !== 'SelectIdentity' && to.name !== 'SelectStore' && to.name !== 'NoStores' && storesArray.length > 0 && !currentStore) {
        next({
          path: '/select-store',
          query: {
            redirect: to.fullPath
          }
        })
        return
      }

      // 如果用户需要选门店但没有门店，跳转到无门店页面
      if (needsStoreSelection && to.name !== 'NoStores' && storesArray.length === 0 && to.name !== 'SelectStore' && to.name !== 'SelectIdentity') {
        next({
          path: '/no-stores'
        })
        return
      }

      next()
    } catch (error) {
      // 登录失效或权限不足，清除本地存储
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('currentStore')
      localStorage.removeItem('stores')

      // 跳转到登录页面
      next({
        path: '/login',
        query: {
          redirect: to.fullPath,
          message: error.message || '登录已过期，请重新登录'
        }
      })
    }
  } else {
    // 不需要认证的路由，直接访问
    next()
  }
})

// 路由后置钩子
router.afterEach((to, from) => {
  // 性能监控：计算路由跳转时间
  const endTime = performance.now()
  const duration = endTime - performance.getEntriesByType('navigation')[0]?.startTime || endTime

  // 开发环境日志
  if (import.meta.env.DEV) {
    console.log(`路由跳转: ${from.path} -> ${to.path} (${duration.toFixed(2)}ms)`)
  }

  // 生产环境性能监控
  if (import.meta.env.PROD) {
    // 这里可以添加性能监控上报逻辑
  }

  // 页面访问统计
  if (to.meta.title) {
    // 这里可以添加页面访问统计逻辑
  }
})

export default router
